import { InjectionToken } from '@angular/core';

export interface JsonDateConfig {
  /** Configure API endpoints where to convert dates. Paths will be matched via "startsWith" ignoring host */
  paths: string[];
}

export const JsonDateInjectConfig = new InjectionToken<JsonDateConfig>(
  'jsondate.config',
);
